import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/home/index.vue";
import Layout from "@/layout/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "layout",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
        meta: { name: "home" }
      },
      {
        path: "/recently",
        name: "recently",
        component: () => import("../views/home/recently.vue"),
        meta: { name: "recently" }
      },
      {
        path: "/internet",
        name: "internet",
        component: () => import("../views/internet/index.vue"),
        meta: { name: "internet" }
      },
      {
        path: "/staking",
        name: "staking",
        component: () => import("../views/staking/index.vue"),
        meta: { name: "staking" }
      },
      {
        path: "/port",
        name: "port",
        component: () => import("../views/port/index.vue"),
        meta: { name: "port" }
      },
       {
        path: "/me",
        name: "me",
        component: () => import("../views/me/index.vue"),
        meta: { name: "me" }
      },
      {
        path: "/withdraw",
        name: "withdraw",
        component: () => import("../views/me/withdraw.vue"),
        meta: { name: "withdraw" }
      },  
      {
        path: "/whitePaper",
        name: "whitePaper",
        component: () => import("../views/whitePaper/index.vue"),
        meta: { name: "whitePaper" }
      },
      {
        path: "/bindapi",
        name: "bindapi",
        component: () => import("../views/bindapi/index.vue"),
        meta: { name: "bindapi" }
      },
      {
        path: "/guide",
        name: "guide",
        component: () => import("../views/whitePaper/guide.vue"),
        meta: { name: "guide" }
      },
    ],
  },
];

// 保存原始方法
const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

// 重写 push 方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 处理重复路由跳转的错误
    if (err.name !== 'NavigationDuplicated') {
      // 如果不是重复跳转错误，将错误继续抛出
      throw err;
    }
  });
};

// 重写 replace 方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.afterEach(() => {
  // 平滑滚动到顶部（兼容大部分浏览器）
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})
export default router;
